import React from "react";
import Router from "./Router";
import GlobalStyle from "./GlobalStyles";
import { useQuery, gql } from "@apollo/client";
import Footer from "./Footer";
import FontListContextProvider from "contexts/font.Context";

const GET_WEBFONT = gql`
  query {
    webFontList {
      webfontname
    }
    fontList(category: "all") {
      idx
      familyname
    }
  }
`;

const App = () => {
  const { data } = useQuery(GET_WEBFONT);




  return (
    <>
      <FontListContextProvider>
        <GlobalStyle data={data} />
        <Router familyName={data?.fontList} />
        <Footer />
      </FontListContextProvider>
    </>
  );
};

export default App;
